import { SERVICES } from '@/data/site'
import { PageHero } from '@/components/PageHero'
import { Icon } from '@/components/Icon'
import { SectionHeading } from '@/components/SectionHeading'
import { CTA } from '@/components/sections/CTA'
import { useReveal } from '@/hooks/useReveal'

const PROCESS = [
  { step: '01', title: '业务咨询', desc: '了解客户需求，明确服务内容与合规边界。' },
  { step: '02', title: '方案制定', desc: '结合经营范围，制定合规、可行的实施方案。' },
  { step: '03', title: '服务交付', desc: '依法依规部署，快速高效完成服务上线。' },
  { step: '04', title: '持续运维', desc: '提供运行维护支持，保障服务稳定运行。' },
]

export default function Services() {
  const processRef = useReveal<HTMLDivElement>()

  return (
    <>
      <PageHero
        eyebrow="核心服务"
        title="专业增值电信业务服务"
        description="依据增值电信业务经营范围，为企业客户提供合规、可靠、高效的互联网信息服务与技术支持。"
      />

      <section className="section services-page">
        <div className="container">
          <SectionHeading
            eyebrow="核心能力"
            title="四大核心服务"
            description="持证经营，依法合规，为您的互联网业务保驾护航。"
          />
          <div className="services-grid">
            {SERVICES.map((service, i) => (
              <article key={service.title} className={`service-card reveal delay-${(i % 4) + 1}`}>
                <div className="service-card-icon">
                  <Icon name={service.icon as never} size={26} />
                </div>
                <h3 className="service-card-title">{service.title}</h3>
                <p className="service-card-desc">{service.description}</p>
                <div className="service-card-tags">
                  {service.tags.map((tag) => (
                    <span key={tag} className="chip">{tag}</span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section process">
        <div className="container">
          <SectionHeading
            eyebrow="协作流程"
            title="透明高效的交付流程"
            description="从第一步沟通到最后上线，每一步都清晰可控。"
          />
          <div className="process-grid" ref={processRef}>
            {PROCESS.map((p, i) => (
              <div key={p.step} className={`process-card reveal delay-${(i % 4) + 1}`}>
                <span className="process-step">{p.step}</span>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  )
}
